import type {
  ModerationDecision,
  ModerationEntityType,
  ModerationOperation,
  Translate,
} from '@/entities/moderation';

const TITLE_FALLBACK: Record<
  ModerationEntityType,
  Record<ModerationOperation, string>
> = {
  products: {
    create: 'Новый товар',
    update: 'Изменение товара',
    delete: 'Удаление товара',
  },
  restaurants: {
    create: 'Новый филиал',
    update: 'Изменение филиала',
    delete: 'Удаление филиала',
  },
  categories: {
    create: 'Новая категория',
    update: 'Изменение категории',
    delete: 'Удаление категории',
  },
  promotions: {
    create: 'Новая акция',
    update: 'Изменение акции',
    delete: 'Удаление акции',
  },
};

/** Modal title — entity × operation, so the ask is named before any content. */
export function reviewTitle(
  entityType: ModerationEntityType,
  operation: ModerationOperation,
  t: Translate,
): string {
  return t(
    `review.title.${entityType}.${operation}`,
    TITLE_FALLBACK[entityType][operation],
  );
}

const PENDING_SUBTITLE: Record<ModerationOperation, string> = {
  create: 'Проверьте информацию и примите решение о публикации',
  update: 'Сравните текущую версию с новой и подтвердите изменения',
  delete: 'Проверьте объект перед удалением и примите решение',
};

/** Modal subtitle — what the reviewer is expected to do in this state. */
export function reviewSubtitle(
  operation: ModerationOperation,
  decision: ModerationDecision,
  t: Translate,
): string {
  if (decision === 'pending') {
    return t(`review.subtitle.${operation}`, PENDING_SUBTITLE[operation]);
  }
  if (decision === 'closed') {
    return t('review.subtitle.closed', 'Заявка закрыта без решения — только просмотр');
  }
  return t('review.subtitle.decided', 'Заявка рассмотрена — только просмотр');
}

const ACTION_FALLBACK: Record<ModerationOperation, { approve: string; reject: string }> =
  {
    create: { approve: 'Одобрить публикацию', reject: 'Отклонить' },
    update: { approve: 'Одобрить изменения', reject: 'Отклонить изменения' },
    delete: { approve: 'Одобрить удаление', reject: 'Отклонить удаление' },
  };

/** Decision captions — approving a delete must read as deleting. */
export function decisionLabels(
  operation: ModerationOperation,
  t: Translate,
): { approve: string; reject: string } {
  return {
    approve: t(`review.action.${operation}.approve`, ACTION_FALLBACK[operation].approve),
    reject: t(`review.action.${operation}.reject`, ACTION_FALLBACK[operation].reject),
  };
}
